import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/landing-page';
import { PrivacyPage } from './pages/privacy-page';
import { TermsPage } from './pages/terms-page';
import { DeleteAccountPage } from './pages/delete-account-page';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
